import { AdjustmentsIcon, ArrowsExpandIcon } from "@heroicons/react/outline";

import { useGridContext } from "../hooks/useEvaluateGridContext";

export const ColumnLayoutSection = () => {
  const { gridApiRef } = useGridContext();

  const handleAutoFill = () => {
    gridApiRef.current?.autoSizeAllColumns();
  };

  const handleFitToScreen = () => {
    gridApiRef.current?.sizeColumnsToFit();
  };

  return (
    <div>
      <h4 className="mb-1.5 text-xs font-medium uppercase tracking-wide text-gray-600">
        Column Width
      </h4>
      <div className="space-y-0.5">
        <button
          className="flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm text-gray-700 transition-colors hover:bg-gray-100"
          onClick={handleAutoFill}
        >
          <AdjustmentsIcon className="h-4 w-4 flex-shrink-0" />
          <div className="min-w-0">
            <div className="font-medium">Expand to content</div>
            <div className="text-xs text-gray-500">Resizes to fit content</div>
          </div>
        </button>
        <button
          className="flex w-full items-center gap-2.5 rounded-md px-2.5 py-1.5 text-left text-sm text-gray-700 transition-colors hover:bg-gray-100"
          onClick={handleFitToScreen}
        >
          <ArrowsExpandIcon className="h-4 w-4 flex-shrink-0" />
          <div className="min-w-0">
            <div className="font-medium">Fit to screen</div>
            <div className="text-xs text-gray-500">Resizes to fill screen</div>
          </div>
        </button>
      </div>
    </div>
  );
};
